module.exports = __webpack_public_path__ + "img/1.bd880378.png";